import React from 'react';
import { Dropdown, DropdownButton, Form, InputGroup } from 'react-bootstrap';

export default function InputText({
    label = '',
    type = 'text',
    placeholder,
    controlId = '',
    required = false,
    onChange = () => { },
    onBlur = () => { },
    onKeypress,
    value,
    error,
    name,
    className,
    disabled,
    min,
    isMobileNumber,
    maxLength,
    displayToolTip = false,
    toolTipText = '',
    autoComplete = 'off',
    mobileCode,
    setMobileCode,
    id,
    icon,
    onIconClick
}) {
    const countryCodes = [
        { code: "+1", label: "US/Canada" },
        { code: "+44", label: "UK" },
    ];

    const handleCodeChange = (code) => {
        setMobileCode(code);
    };

    const formControl = (
        <Form.Control
            onBlur={onBlur}
            type={type}
            placeholder={placeholder}
            onChange={onChange}
            value={value || ''}
            required={required}
            name={name}
            isInvalid={error}
            disabled={disabled}
            min={min}
            maxLength={maxLength}
            onWheel={(e) => type === 'number' && e.target.blur()}
            autoComplete={autoComplete}
            onKeyDown={(e) => {
                if (isMobileNumber) {
                    if (e.which !== 8 && e.which !== 13 && (e.which < 48 || e.which > 57)) {
                        e.preventDefault();
                    }
                }
            }}
        />
    );

    return (
        <div className={className || ''}>
            <Form.Group className='form-group' controlId={controlId}>
                <Form.Label>
                    <div className='tooltip-container'>
                        {label}
                        {displayToolTip && (
                            <img
                                style={{ margin: '0 8px' }}
                                src='/images/tooltip.png'
                                alt='Question mark'
                                title={toolTipText}
                            />
                        )}
                    </div>
                </Form.Label>
                {id?.endsWith('_code') ? (
                    <InputGroup hasValidation={true}>
                        <DropdownButton
                            as={InputGroup.Prepend}
                            variant="dark"
                            title={mobileCode}
                            id="mobile-code-dropdown"
                        >
                            {countryCodes?.map((country) => (
                                <Dropdown.Item
                                    key={country.code}
                                    onClick={() => handleCodeChange(country.code)}
                                >
                                    {country.code} ({country.label})
                                </Dropdown.Item>
                            ))}
                        </DropdownButton>
                        {formControl}
                        <Form.Control.Feedback type='invalid'>{error}</Form.Control.Feedback>
                    </InputGroup>
                ) : icon ? (
                    <InputGroup hasValidation={true}>
                        {formControl}
                        <InputGroup.Text onClick={onIconClick} style={{ cursor: 'pointer' }}>
                            {icon}
                        </InputGroup.Text>
                        <Form.Control.Feedback type='invalid'>{error}</Form.Control.Feedback>
                    </InputGroup>
                ) : (
                    <>
                        {formControl}
                        <Form.Control.Feedback type='invalid'>{error}</Form.Control.Feedback>
                    </>
                )}
            </Form.Group>
        </div>
    );
}
